import './styles.scss'
import 'react-perfect-scrollbar/dist/css/styles.css'
import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'

export default class Index extends React.Component {
  constructor() {
    super()

    this.state = {
      showScrollTo: false,
      showMore: false,
      pageCounter: 0
    }

    this._scrollRef = {}
    this.handleScroll = this.handleScroll.bind(this)
    this.handleScrollTo = this.handleScrollTo.bind(this)
    this.handleNextPage = this.handleNextPage.bind(this)
  }

  componentDidMount() {
    if (this.props.goToBottom) {
      setTimeout(() => {
        this._scrollRef.scrollTop = this._scrollRef.scrollHeight
      }, 50)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      goToTop: prevGoToTop,
      goToBottom: prevGoToBottom,
      goToId: prevGoToId,
      children: prevChildren
    } = prevProps
    const {
      goToTop,
      goToBottom,
      goToId,
      children
    } = this.props

    if (prevGoToTop !== goToTop || prevGoToBottom !== goToBottom) {
      if (this.props.goToBottom) {
        this._scrollRef.scrollTop = this._scrollRef.scrollHeight
      } else {
        this._scrollRef.scrollTop = 0
      }
    }

    if (goToId && (prevChildren !== children || prevGoToId !== goToId)) {
      const messageNode = document.getElementById(goToId)
      if (messageNode) this._scrollRef.scrollTop = messageNode.offsetTop
    }
  }

  handleScroll() {
    if (this.props.goToTop) {
      this.setState({ showScrollTo: this._scrollRef.scrollTop > 750 })
      if (this.props.isUserList) {
        if ((this.state.pageCounter + 1) * 100 > this.props.userSize) {
          this.setState({ showMore: false })
        } else {
          this.setState({ showMore: this._scrollRef.scrollTop > 5000 })
        }
      }
    } else if (this.props.goToBottom) {
      const scroll = this._scrollRef
      const showScrollTo = scroll.scrollTop < scroll.scrollHeight - 750
      this.setState({ showScrollTo })
    }
  }

  handleScrollTo() {
    if (this.props.goToTop) {
      this._scrollRef.scrollTop = 0
    } else {
      this._scrollRef.scrollTop = this._scrollRef.scrollHeight
    }
  }

  handleNextPage() {
    this.props.handleNextPage(this.state.pageCounter + 1)
    this.setState({ pageCounter: this.state.pageCounter + 1 })
  }

  render() {
    const {
      goToTop, goToBottom, goToId, userSize, children, handleNextPage,
      isUserList, ...rest
    } = this.props

    return (
      <PerfectScrollbar
        containerRef={(ref) => (this._scrollRef = ref)}
        onScrollDown={this.handleScroll}
        onScrollUp={this.handleScroll}
        {...rest}
      >
        {children}

        {this.state.showScrollTo && (
          <div onClick={this.handleScrollTo} className='go-to-top'>
            <i className={`fa fa-chevron-${goToTop ? 'up' : 'down'}`} />
          </div>
        )}
        {this.state.showMore && (
          <div onClick={this.handleNextPage} className='show-more'>
            <i className={`fa fa-plus`} />
          </div>
        )}
      </PerfectScrollbar>
    )
  }
}

Index.defaultProps = {
  goToTop: false,
  goToBottom: false,
  goToId: ''
}
